import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '@/shared/components/Button/Button'
import TextComponent from '@/shared/components/TextComponent/TextComponent'
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'

import styles from '@/features/auth/Forms/Login/Login.module.scss'

import { useLoginFormConfig } from '@/features/auth/Forms/Login/useLoginFormConfig'

function Login() {
  const { t } = useTranslation()

  const formConfig = useLoginFormConfig()
  return (
    <div className={`${styles.loginContainer}`}>
      <h1 className={`title-bold-medium ${styles.loginHeader}`}>
        {t('AUTHORIZATION.LOGIN')}
      </h1>
      <DynamicForm condensed validationMode="onSubmit" {...formConfig} />
      <div className={`${styles.loginFormButtonContainer}`}>
        <div className={`${styles.loginHelpContainer}`}>
          {/* <div className={`${styles.accountHelpGroup}`}>
            <p
              className={`body-bold-medium ${styles.dontHaveAnAccountMessage}`}
            >
              {t('AUTHORIZATION.LOGIN.DONT_HAVE_ACCOUNT')}
            </p>
            <div className={`${styles.writeEmailMessageContainer}`}>
              <p className={`body-bold-medium ${styles.writeEmailMessage}`}>
                {t('AUTHORIZATION.LOGIN.WRITE_MESSAGE')}
              </p>
              <span className={`${styles.writeEmailAddress}`}>
                <TextComponent
                  text="pepek@pepek.com"
                  fontSize="body-bold-medium"
                  color="secondary"
                />
              </span>
            </div>
          </div> */}
          <NavLink
            className={`${styles.forgotPasswordLink}`}
            to="/reset-password"
          >
            <TextComponent
              text={t('AUTHORIZATION.LOGIN.FORGOT_PASSWORD')}
              fontSize="body-bold-medium"
              color="primary"
            />
          </NavLink>
        </div>
        <Button
          form="login-form"
          onClick={() => null}
          label={t('AUTHORIZATION.LOGIN')}
          variant="contained"
          color="primary"
          type="submit"
          maxWidth
        />
      </div>
    </div>
  )
}

export default Login
